<div class="title">
  <p-heading [size]="'x-large'" [tag]="'h3'">Education Category</p-heading>

  <p-button
    [hideLabel]="(mediaMaxXs$ | async) ?? false"
    [iconSource]="'assets/icons/add.svg'"
    [variant]="'secondary'"
    (click)="showCreateModal = true"
  >
    Add New Category
  </p-button>
</div>

<p-divider aria-hidden="true" />

<section class="list">
  <p-heading *ngrxLet="data$ | async as categories" [size]="'small'" [tag]="'h4'">
    {{ categories?.length }} Categories
  </p-heading>

  <ng-container *ngrxLet="data$ as data; error as dataError; suspenseTpl: spinner">
    <div *ngIf="dataError">
      <p-button-pure
        [hideLabel]="true"
        [iconSource]="'assets/icons/refresh.svg'"
        [size]="'large'"
        (click)="reloadData()"
      >
        Reload Categories
      </p-button-pure>
    </div>

    <ng-container *ngIf="!dataError && data">
      <div class="overlay-spinner-host">
        <ng-container *ngIf="loading$ | async" [ngTemplateOutlet]="overlaySpinner" />

        <p-table caption="Edu Category list table">
          <p-table-head>
            <p-table-head-row>
              <p-table-head-cell style="width: 1%">Edit</p-table-head-cell>
              <p-table-head-cell style="width: 49%">Name</p-table-head-cell>
              <p-table-head-cell style="width: 49%">Type</p-table-head-cell>
              <p-table-head-cell style="width: 1%">Delete</p-table-head-cell>
            </p-table-head-row>
          </p-table-head>

          <p-table-body>
            <p-table-row *ngFor="let category of data; trackBy: trackEduExpenseCategory">
              <p-table-cell>
                <p-button-pure
                  [iconSource]="'assets/icons/edit.svg'"
                  [hideLabel]="true"
                  (click)="openEditModal(category)"
                >
                  Edit {{ category.description }}
                </p-button-pure>
              </p-table-cell>
              <p-table-cell>
                <p-link-pure [icon]="'none'" [underline]="true">
                  <a
                    [routerLink]="['/edu-transactions']"
                    [queryParams]="{ expenseCategoryId: category.id }"
                  >
                    {{ category.description }}
                  </a>
                </p-link-pure>
              </p-table-cell>
              <p-table-cell>
                {{ budgetTypeTranslation[category.budgetType] | transloco }}
              </p-table-cell>
              <p-table-cell>
                <p-button-pure
                  [iconSource]="'assets/icons/delete.svg'"
                  [hideLabel]="true"
                  (click)="openDeleteModal(category)"
                >
                  Delete {{ category.description }}
                </p-button-pure>
              </p-table-cell>
            </p-table-row>
          </p-table-body>
        </p-table>
      </div>
    </ng-container>
  </ng-container>
</section>

<opa-edu-expense-category-create
  [open]="showCreateModal"
  (dismiss)="showCreateModal = false; $event && reloadData()"
/>

<ng-template #spinner>
  <div class="loading-spinner"><p-spinner /></div>
</ng-template>

<ng-template #overlaySpinner>
  <div class="overlay-spinner"><p-spinner /></div>
</ng-template>

<opa-edu-expense-category-delete
  [open]="showDeleteModal"
  [eduExpenseCategory]="(eduExpenseCategory$ | async) ?? undefined"
  (dismiss)="closeDeleteModal($event)"
/>

<opa-edu-expense-category-edit
  [open]="showEditModal"
  [eduExpenseCategory]="(eduExpenseCategory$ | async) ?? undefined"
  (dismiss)="closeEditModal($event)"
/>
